import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import authentication from "./authentication";
import user from "./user";
import administrationTimeSheet from "./admin/timesheet";
import administrationCustomer from "@/store/admin/customer";
import administrationContract from "@/store/admin/contract";
import administrationInvoice from "@/store/admin/invoice";
import timesheet from "@/store/timesheet";
import administrationUser from "./admin/user";
import errorHandling from "./errorHandling";
import warningHandling from "./warningHandling";
import time from "@/store/time";
import confirmedEmail from "./admin/confirmedEmail";

Vue.use(Vuex);

const store = new Vuex.Store({
	namespaced: true,
	modules: {
		administrationContract,
		administrationCustomer,
		administrationTimeSheet,
		administrationUser,
		administrationInvoice,
		authentication,
		errorHandling,
		warningHandling,
		timesheet,
		user,
		time,
		confirmedEmail
	},
	plugins: [
		createPersistedState({
			paths: ["administrationTimeSheet",
				"administrationContract",
				"administrationCustomer",
				"administrationUser",
				"administrationInvoice",
				"time",
				"confirmedEmail"
			]
		})
	]
});

export default store;
